import $ from 'jquery';
import store from '../index';

const state = {
  metadata: {
    fetch: true,
    collection: [],
  },
  locales: {
    fetch: true,
    collection: {},
  },
  locale: '',
  inputingLocale: ''
};

const getters = {
  metadata: ({metadata}) => metadata.collection,
  locale: (state) => state.locale,
  locales: (state) => state.locales.collection,
  inputingLocale: (state) => state.inputingLocale,
};

const actions = {
  fetchAppMetadata({commit}) {
    $.ajax({
      url: '/api/metadata',
      success: (result) => {
        commit('SET_METADATA_INDEX', result);
      },
    });
  },
  fetchAppLocales({commit}) {
    $.ajax({
      url: '/api/locales',
      success: (result) => {
        commit('SET_LOCALES_INDEX', result);
      },
    });
  },
  setLocale({commit}, locale) {
    commit('SET_INPUTING_LOCALE', locale);
  }
};

const mutations = {
  SET_METADATA_INDEX: ({metadata}, data) => {
    metadata.collection = data;
    metadata.fetch = false;
  },
  SET_LOCALES_INDEX: ({locales}, data) => {
    locales.collection = data;
    locales.fetch = false;
  },
  SET_LOCALE: (state, newLocale) => {
    state.locale = newLocale
  },
  SET_INPUTING_LOCALE: (state, newLocale) => {
    state.inputingLocale = newLocale
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
export const strict = false;


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/shell.js